import '@babel/polyfill';
import React from 'react';
import { render } from 'react-dom';

import RailHightlightApp from '@railHightlight';

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

/**
 * Render app coverage with the provided target
 * This file is the same as index.js except it add a window function to render the react app.
 * @param  {DOMElement} target  Element in which render the coverage react app
 */
document.querySelectorAll('[data-rail-type]').forEach(element => {
  element.innerHTML = '';
  render(
    <RailHightlightApp
      railType={element.getAttribute('data-rail-type')}
      railTitle={element.getAttribute('data-rail-title')}
      railCategory={element.getAttribute('data-rail-category')}
    />,
    element,
  );
});
